import { BookingIntent, StockTargetType } from '../types';
import { BookingRequest } from './booking-request';
import { FromBuilder } from './from-builder';

/**
 * Builder-Stage für Quelle = Maschine. Bietet alle fachlich sinnvollen
 * Ziel-Auswahlen an, die von einer Maschine aus möglich sind.
 */
export class FromMachineBuilder extends FromBuilder {
  /**
   * Maschine → KFZ: Rückbuchung von Serviceartikeln bei Service. Erzeugt ein
   * NormalMovement.
   *
   * @param id ID des Ziel-KFZ
   * @returns Finale Builder-Stage mit `validate()`/`submit()`
   */
  public toCar(id: number): BookingRequest {
    return this.next(StockTargetType.CAR, id, BookingIntent.MOVE);
  }

  /**
   * Maschine zum Disposal-Anker am Bufferstock (MachineTrashMovement): der
   * Bufferstock erhält eine `PositionDisposal` für die spätere Entsorgung.
   * Backend invertiert source/target: source = Bufferstock, target = Maschine.
   *
   * @param bufferstockId ID des Bufferstocks, der die Disposal-Position erhält
   * @returns Finale Builder-Stage mit `validate()`/`submit()`
   */
  public toBufferstockDisposal(bufferstockId: number): BookingRequest {
    return new BookingRequest(
      this.orchestrator,
      this.systemContext,
      {
        ...this.bookingContext,
        targetType: StockTargetType.BUFFERSTOCK_DISPOSAL,
        targetId: bufferstockId,
        intent: BookingIntent.BUFFERSTOCK_DISPOSAL,
      },
      this.services,
      this.positions,
    );
  }
}
